/**
 * Las direcciones de la API, todas acá.
 *
 * Estaban escritas a mano en cada pantalla: noventa y cuatro cadenas de texto, cincuenta
 * distintas, `/api/catalogs/products` repetida once veces en seis archivos. Una ruta que cambia
 * del lado del servidor obligaba a buscarla con grep por todo el frontend, y una letra de más no
 * la encuentra el compilador: la encuentra alguien en producción, con un 404.
 *
 * Las que llevan algo adentro son funciones, y acá adentro queda decidido qué se escapa y qué no.
 * Ese detalle estaba desparejo —el catálogo público escapaba el código del producto y el panel
 * no— y se deja exactamente como estaba, porque cambiarlo cambia a qué responde la API para un
 * código con un espacio. Está anotado donde pasa.
 */

export const RUTAS = {
  sesion: {
    entrar: '/api/auth/login',
    salir: '/api/auth/logout',
    quienSoy: '/api/auth/me',
    captcha: '/api/captcha',
    cambiarClave: '/api/users/change-password',
  },

  catalogo: {
    productos: '/api/catalogs/products',
    categorias: '/api/catalogs/categories',
    /** Los rubros con su foto y su cuenta, para la portada y la página de rubros. */
    categoriasEnTarjetas: '/api/catalogs/categories/cards',
    marcas: '/api/catalogs/brands',
    excel: '/api/catalogs/products/excel',

    /** Escapa el código: así lo pide el catálogo público desde que existe. */
    fotosDelProducto: (codigo: string) =>
      `/api/catalogs/products/${encodeURIComponent(codigo)}/images`,

    pdf: (marca: string) => `/api/catalogs/pdf/${marca.toLowerCase()}`,
  },

  catalogos: {
    lista: '/api/catalogs',
    uno: (id: string) => `/api/catalogs/${id}`,
    activar: (id: string) => `/api/catalogs/${id}/set-active`,
    renombrar: (id: string) => `/api/catalogs/${id}/rename`,
    descargar: (id: string) => `/api/catalogs/${id}/download`,
    subir: '/api/upload-catalog',
    probar: '/api/upload-catalog/preview',
  },

  imagenes: {
    lista: '/api/images',
    subir: '/api/images/upload',
    subirLote: '/api/images/upload-batch',
    borrarLote: '/api/images/delete-batch',
    descargarTodas: '/api/images/download-bulk',
    una: (id: string) => `/api/images/${id}`,

    /** Una de las tres colecciones de la portada: `hero`, `novedades` u `offers`. */
    coleccion: (ruta: string) => `/api/images/${ruta}`,
    coleccionPublica: (ruta: string) => `/api/images/${ruta}/public`,

    /** Qué productos tienen foto y cuáles no. */
    cobertura: '/api/products/image-status',

    /** Las fotos de un producto, desde el panel. No escapa el código: así estaba. */
    delProducto: (codigo: string) => `/api/products-management/${codigo}/images`,
  },

  productos: {
    lista: '/api/products-management',
    uno: (id: string) => `/api/products-management/${id}`,
    categorias: '/api/products-management/categories',
  },

  usuarios: {
    lista: '/api/users',
    uno: (id: string) => `/api/users/${id}`,
    reiniciarClave: (id: string) => `/api/users/${id}/reset-password`,
  },

  consultas: {
    /** La misma dirección manda el formulario y lista lo que llegó; cambia el método. */
    raiz: '/api/contact',
    una: (id: string) => `/api/contact/${id}`,
    leida: (id: string) => `/api/contact/${id}/read`,
    archivar: (id: string) => `/api/contact/${id}/archive`,
  },

  piezasDelPdf: {
    lista: '/api/catalog-assets',
    publica: '/api/catalog-assets/public',
  },

  metricas: {
    registrarVisita: '/api/analytics/track',
    resumen: '/api/analytics/summary',
    registros: '/api/activity-logs',
    tablero: '/api/dashboard/stats',
  },
} as const;
